<button
  procure-button
  color="white"
  condensed
  [class]="`toggle-button ${placement()}`"
  [matTooltip]="isExpanded() ? 'Collapse Navigation' : 'Expand Navigation'"
>
  <mat-icon class="toggle-icon">
    {{ icon() }}
  </mat-icon>
</button>
